export default __webpack_public_path__ + "static/media/Video1.d37cff37.mov";